const version = require('../../package.json').version

function convertUrl(url, to) {
  return url.replace('admin', to)
}

function getEnv() {
  const { protocol, hostname } = window.location
  const envs = {
    development: {
      apiURL: process.env.VUE_APP_API_URL,
      uploadURL: process.env.VUE_APP_UPLOAD_URL,
      version,
    },
    production: {
      apiURL: convertUrl(`${protocol}//${hostname}`, 'api'),
      uploadURL: 'https://cloud.dentalgo.com.br',
      version,
    },
  }
  return envs[process.env.NODE_ENV]
}

export default getEnv()
